/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/*
 * External dependencies
 */
import type { SRViewProps } from '@nab/types';

/**
 * Internal dependencies
 */
import type { Attributes } from './types';

export const View = ( {
	attributes: { condition },
}: SRViewProps< Attributes > ): JSX.Element => {
	switch ( condition ) {
		case 'is-new-visitor':
			return <>{ _x( 'Visitor is new.', 'text', 'nelio-ab-testing' ) }</>;
		case 'is-returning-visitor':
			return (
				<>
					{ _x(
						'Visitor is returning.',
						'text',
						'nelio-ab-testing'
					) }
				</>
			);
	}
};
